export enum PaymentStatuses {
  started = "started",
  paid = "paid",
  failed = "failed",
  completed = "completed",
  cancelled = "cancelled",
}
